
import { toFloat64, toString, fromParts, op_Division, parse } from "../fable_modules/fable-library-js.5.0.0-alpha.22/Decimal.js";
import { replace } from "../fable_modules/fable-library-js.5.0.0-alpha.22/String.js";
import { filter, length } from "../fable_modules/fable-library-js.5.0.0-alpha.22/Seq.js";
import { isDigit } from "../fable_modules/fable-library-js.5.0.0-alpha.22/Char.js";
import { empty, ofArrayWithTail, cons, head, reverse, tail, isEmpty } from "../fable_modules/fable-library-js.5.0.0-alpha.22/List.js";

export function Decimal_ParseDe_Z721C83C5(value) {
    return parse(replace(replace(value, ".", ""), ",", "."));
}

export function Decimal_Normalize_32C73145(value) {
    return op_Division(value, fromParts(268435456, 1042612833, 542101086, false, 28));
}

export function Decimal_Length_32C73145(value) {
    return length(filter(isDigit, toString(value).split(""))) | 0;
}

export function Decimal_Format_32C73145(value) {
    const s = toString(value);
    const index = s.indexOf(".") | 0;
    const decimalPlaces = ((index === -1) ? 0 : ((s.length - index) - 1)) | 0;
    const format = new Intl.NumberFormat("de-DE", ({
        maximumFractionDigits: decimalPlaces,
    }));
    return format.format(toFloat64(value));
}

export function List_intersperse(sep, lst) {
    const loop = (acc_mut, _arg_mut) => {
        loop:
        while (true) {
            const acc = acc_mut, _arg = _arg_mut;
            if (!isEmpty(_arg)) {
                if (isEmpty(tail(_arg))) {
                    return reverse(cons(head(_arg), acc));
                }
                else {
                    acc_mut = ofArrayWithTail([sep, head(_arg)], acc);
                    _arg_mut = tail(_arg);
                    continue loop;
                }
            }
            else {
                return reverse(acc);
            }
            break;
        }
    };
    return loop(empty(), lst);
}

